import { z } from "zod";

import { ShippingRateDtoSchema } from "./shipping-rates";

export const RateGroupTypeList = [
  "flatRate",
  "flatRateWithThreshold",
  "thresholdOnly",
  "tieredByPriceOrWeight",
  "custom",
] as const;
export type RateGroupType = (typeof RateGroupTypeList)[number];

export const ShippingRateGroupDtoSchema = z.object({
  groupType: z.enum(RateGroupTypeList),
  position: z.number(), // rendering order
  rates: ShippingRateDtoSchema.array(),
  id: z.string().uuid(),
  variationId: z.string().uuid(),
});
export type ShippingRateGroupDto = z.infer<typeof ShippingRateGroupDtoSchema>;

export const CreateShippingRateGroupDtoSchema =
  ShippingRateGroupDtoSchema.extend({
    id: z.string().uuid().optional(),
  });

export type CreateShippingRateGroupDto = z.infer<
  typeof CreateShippingRateGroupDtoSchema
>;
